export const CROSS_LABEL = {
  match_hs10: "완전일치(HS10)",
  match_hs6: "HS6 일치",
  mismatch: "불일치(검토)",
  leg2_failed: "AI실패·evidence사용",
  leg1_failed: "evidence실패·AI사용",
  both_failed: "둘 다 실패",
  prove: "PROVE 모델",
  model_unavailable: "모델 서버 꺼짐",
};
export const CONFIDENCE_LABEL = {
  high: "높음",
  medium: "보통",
  low: "낮음",
  none: "없음",
};

export function crossLabel(cross) {
  return CROSS_LABEL[cross] ?? (cross || "");
}
export function confidenceLabel(c) {
  return CONFIDENCE_LABEL[c] ?? (c || "");
}
export function confidenceBadgeClass(c) {
  return `bulk-badge bulk-badge-${c || "none"}`;
}

export function masterLabel(m) {
  switch (m) {
    case "match":
      return "일치";
    case "hs6":
      return "HS6";
    case "mismatch":
      return "불일치";
    case "unverified":
      return "미검증";
    default:
      return "";
  }
}

/** 은은히 강조할 검토필요 행: 실패/불일치/저신뢰. */
export function needsReview(row) {
  const mm = row && row.masterMatch;
  if (mm && mm !== "none") return mm === "mismatch" || mm === "unverified";
  if (!row) return false;
  return (
    row.status === "error" ||
    row.cross === "mismatch" ||
    row.confidence === "low" ||
    row.confidence === "none"
  );
}
